import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, delay, EMPTY, map, switchMap, tap } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { DialogService } from '../shared/dialogs/dialog.service';


@Component({
  selector: 'authentication-signin-testing',
  imports: [MatProgressBarModule],
  template: `
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  `
})
export class SigninTestingComponent {

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);
  private dialogService = inject(DialogService);

  email = toSignal(this.route.queryParamMap.pipe(map(params => params.get('email'))));
  password = toSignal(this.route.queryParamMap.pipe(map(params => params.get('password'))));

  constructor() {
    const email = this.email();
    const password = this.password();
    if (!email || !password) {
      console.error('Testing sign-in requires email and password query parameters.');
      this.router.navigate(['/authentication/signin']);
      return;
    }

    this.authenticationService.signInWithEmailAndPassword(email, password).pipe(
      delay(500), // Simulate a delay (required for testing purposes)
      switchMap(result => {
        if (result === 'signed-in') {
          this.router.navigate(['/dashboard']);
          return EMPTY;
        }

        return this.dialogService.acknowledge(
          'Login Disabled',
          'This user is not enabled for logging in.',
          '320px'
        ).pipe(
          tap(() => this.router.navigate(['/authentication/signin']))
        );
      }),
      catchError((error) => {
        console.log('sign in error:', error)
        throw error
        })

    ).subscribe();
  }

}
